export function scrollToPageTarget(target, { behavior = 'smooth', block = 'start' } = {}) {
  if (!target) return;

  const appMain = target.closest('.world-app-main');
  const mobile = window.matchMedia('(max-width: 850px)').matches;
  let container;
  let offset;

  if (appMain) {
    for (let ancestor = target.parentElement; ancestor && ancestor !== appMain; ancestor = ancestor.parentElement) {
      const overflow = window.getComputedStyle(ancestor).overflowY;
      if ((overflow === 'auto' || overflow === 'scroll') && ancestor.scrollHeight > ancestor.clientHeight) {
        container = ancestor;
        break;
      }
    }
    container ||= target.closest(mobile ? '.world-app-content-scroll' : '.world-right') || appMain;
    offset = mobile && container.classList.contains('world-app-content-scroll') ? 16 : 80;
    // An anchor must never move the shell that contains the navigation bar.
    if (container !== appMain) appMain.scrollTop = 0;
  } else {
    container = target.closest('.portal-content[data-page-scroll], .portal-main');
    offset = container?.classList.contains('portal-content') ? 16 : container ? 80 : document.querySelector('.public-header') ? 80 : 0;
  }

  const viewportTop = container?.getBoundingClientRect().top || 0;
  const targetTop = target.getBoundingClientRect().top;
  const top = (container ? container.scrollTop : window.scrollY) + targetTop - viewportTop - offset;
  const scrollOptions = { top: Math.max(0, block === 'center' ? top - (container?.clientHeight || window.innerHeight) / 2 + target.clientHeight / 2 : top), behavior };
  if (container) container.scrollTo(scrollOptions);
  else window.scrollTo(scrollOptions);
}
